<template>
  <div class="main">
    <div class="topBanner">
      <banner-bg></banner-bg>
      <div class="banseo">
        <div class="banjz"></div>
        <input
          v-model="searchText"
          type="text"
          class="bantxt"
          id="searchtxt"
          placeholder="输入互动名称关键字.."
        /><button class="btn banbutt" type="button" @click="filter">
          <i class="fa fa-chevron-circle-right"></i>搜一搜
        </button>
        <span
          class="seoicn"
          style="color: rgb(176, 190, 197); transition: all 1.5s ease 0s;"
          ><i class="fa fa-search"></i
        ></span>
      </div>
    </div>
    <div class="scrollCon">
      <div class="viceNav " :class="{ menuFixed: searchBarFixed }">
        <div class="yn jz container-fluid nav-bg m0" id="menu_wrap">
          <div class="centerCon">
            <div class="container m0" style="position:relative;">
              <a
                class="nzz"
                :class="{ 'nav-zibg': index == currMenu }"
                href="###"
                :key="index"
                v-for="(val, index) in mtype"
                @mouseenter="showChildMenu(index)"
                @mouseleave="closeMenu()"
                ><span class="sort"
                  ><i class="fa fa-paint-brush"></i>&nbsp;{{ val }}
                  <i class="fa fa-angle-down"></i></span
              ></a>
            </div>
            <div class="container-fluid" v-show="showmenuStatus">
              <div id="n1" class="nav-zi ty">
                <ul
                  id="nz1"
                  class="nn list-inline container m0 nadc"
                  style="display: block;"
                  @mouseenter="retainShowMenu()"
                  @mouseleave="closeMenu()"
                >
                  <li v-for="(item, index) in menuRenderList" :key="index">
                    <a class="c-btn c-btn--border-line" href="###"
                      ><i class="fa fa-delicious ls"></i> {{ item.title }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content-container"
        style="transition: all 1.5s ease 0s;"
        :style="!!showmenuStatus ? 'filter:blur(5px)' : ''"
      >
        <div class="breadcrumb">
          <span>在线小班互动大全</span>
        </div>
        <span
          v-show="JSON.stringify(showData) == '{}'"
          style="padding-left: 20px;"
          >为您找到相关结果0个</span
        >
        <el-row :gutter="20">
          <el-col
            :span="6"
            v-for="(item, index) in showData"
            :key="index"
            class="listItem"
          >
            <el-card :body-style="{ padding: '0px' }">
              <div class="imgCon" :style="'background:' + randomBgColor(index)">
                <img :src="'../../../static/img/m/' + item.img" class="image" />
              </div>
              <div style="padding: 14px;">
                <span>{{ item.title }}</span>
                <div class="bottom clearfix">
                  <!-- <time class="time">{{ 1 }}</time> -->
                  <el-button type="text" class="button">查看</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div class="breadcrumb">
          <span>年级链接</span>
        </div>
        <el-card class="box-card">
          <!-- <div v-for="(item, index) in gdata" :key="index" class="text item">
            {{ "列表内容 " + item.name }}
          </div> -->
          <el-table :data="gdata" style="width: 100%">
            <el-table-column prop="name" label="课次" width="180">
            </el-table-column>
            <el-table-column label="链接">
              <template slot-scope="scope">
                <a :href="scope.row.url"> {{ scope.row.url }}</a>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" @click="gotoView(scope.row.url)"
                  >跳转</el-button
                >
              </template>
            </el-table-column>
            <!-- <el-table-column prop="address" label="地址"> </el-table-column> -->
          </el-table>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { post, notice } from "../../../static/js/common";
import { mdata } from "./data";
import { mtype } from "./type";
import { gradeData } from "./grade";

import BannerBg from "./bannerBg";

export default {
  data() {
    return {
      mdata: mdata,
      mtype: mtype,
      gdata: gradeData,
      searchText: "",
      showData: null,
      searchBarFixed: false,
      activeIndex: "1",
      showmenuStatus: false,
      menuRenderList: [],
      currMenu: -1,
      timeout: null
    };
  },
  components: {
    BannerBg
  },
  created() {
    // 发送 POST 请求
    this.mdata = mdata;
    this.showData = this.mdata;
  },
  computed: {},
  methods: {
    gotoView(url) {
      window.open(url);
    },
    filter() {
      if (this.searchText.trim() === "") {
        this.showData = this.mdata;
      }
      let showDataPre = {};
      for (let key in this.mdata) {
        if (this.mdata[key].title.includes(this.searchText)) {
          showDataPre[key] = this.mdata[key];
        }
      }
      this.showData = showDataPre;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.searchBarFixed = scrollTop > 466; // 44px是导航标题头的高度
    },
    showChildMenu(type) {
      this.menuRenderList = this.navRenderList(type);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.showmenuStatus = !!1;
      }, 200);
    },
    closeMenu() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.showmenuStatus = false;
      }, 200);
    },
    retainShowMenu() {
      clearTimeout(this.timeout);
    },
    navRenderList(type) {
      return this.mdata.filter(el => el.type == type);
    },
    randomBgColor(index) {
      const colorArr = ["#4fe56d", "#5d9c7e", "#ee4003", "#fa9537", "ff5959"];
      // const randomNum = Math.floor(Math.random() * 5);
      return colorArr[index % 4];
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../static/css/my.css";
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.menuFixed {
  position: fixed;
  left: 0;
  z-index: 10;
  width: 100%;
  top: 0;
}
.topBanner {
  position: fixed;
}
.scrollCon {
  position: relative;
  top: 402px;
  background: #fff;
}
.main {
  width: 100%;
  position: relative;
  top: 57px;
  .content-container {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    margin-bottom: 50px;
  }
  .breadcrumb {
    margin-top: 30px;
    font-size: 16px;
    padding-left: 20px;
    padding-bottom: 0px;
    padding-right: 0px;
    padding-top: 0px;
    margin-bottom: 15px;
    color: #262626;
    font-family: Vrinda;
    font-weight: 700;
  }
}
.viceNav {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background: #fff;
  margin-bottom: 50px;
  .viceNav-container {
    width: 1200px;
    height: auto;
    margin: 0 auto;
  }
  .centerCon {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
  }
}
.banseo {
  top: 126px;
  width: 728px;
  height: 34px;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
  .bantxt {
    width: 100%;
    height: 60px;
    opacity: 1;
    background-color: #eceff1;
    border-radius: 5px;
    border: 0px;
    padding-left: 50px;
    color: #000;
    padding-right: 20px;
    outline: none;
    box-sizing: border-box;
  }
  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
  }
  .banbutt {
    position: absolute;
    right: 0px;
    background-color: transparent;
    border-width: 0px;
    outline: none;
    height: 60px;
    width: 173px;
    background-color: #ec4d1c;
    border: 0px;
    color: #fff;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    transition: all 0.7s ease 0s;
    font-size: 15px;
    background: -webkit-linear-gradient(top, #f4511e 0, #d84315 100%);
    background: linear-gradient(to bottom, #f4511e 0, #d84315 100%);
    &:hover {
      background-color: #ed3800;
      background: -webkit-linear-gradient(top, #f03900 0, #bb2c00 100%);
      background: linear-gradient(to bottom, #f03900 0, #bb2c00 100%);
    }
  }
  .seoicn {
    position: absolute;
    left: 18px;
    top: 25px;
    color: #b0bec5;
    font-size: 18px;
  }
}
.listItem {
  margin-bottom: 20px;
  border-radius: 5px;
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  position: relative;
  transition: all 1s ease 0s;
  overflow: hidden;
  // &:hover {
  //   box-shadow: 0 1px 1px rgba(0, 0, 0, 0.7);
  // }
  &:hover .imgCon {
    filter: brightness(0.5);
    transform: scale(1.1);
  }
  // &:hover img {
  //   transform: scale(1.1);
  // }
  .imgCon {
    width: 100%;
    height: 175px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #4fe56b;
    transition: all 1s ease 0s;

    img {
      width: 90%;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      cursor: pointer;
    }
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/components/index/content.vue